const formatAmountBRL = (amount) => Number(amount).toFixed(2).replace('.', ',');

// projeção do AcquisitionOffer (services/pricingCatalog) pro shape que
// CompleteProfile já sabe renderizar/enviar em CREATE_SUBSCRIPTION.
export const mapAcquisitionOfferToCompleteProfilePlan = (offer) => ({
  id: offer.plan.id,
  internal_id: offer.tier,
  name: offer.tier_display_name,
  amount: formatAmountBRL(offer.amount),
  price: offer.amount,
  billing_type: offer.billing_type,
  gateway_id: String(offer.plan.gateway_id),
});
